import { BuilderDataWithSelectorProps } from 'src/containers/formBuilder/formTypeProvider';
import { useMonitoringFormSelector } from './useMonitoringFormSelector';
import { useMonitoringFormHandlers } from './useMonitoringFormHandlers';
import { useMonitoringFormsConfigPanel } from '../configPanel/useMonitoringFormsConfigPanel';
import { EMPTY_LAYOUT } from 'src/containers/formBuilder/formBuilder';
import { SerializedNodes } from '@craftjs/core';

export const useMonitoringFormBuilderProps = (options?: { enabled?: boolean }): BuilderDataWithSelectorProps => {
  const selector = useMonitoringFormSelector(options);
  const panel = useMonitoringFormsConfigPanel({ initialTitle: selector.selectedConfig?.title });
  const handlers = useMonitoringFormHandlers({
    selectedConfigId: selector.selectedConfig?.id,
    setConfigId: selector.setConfigId,
    initialTitle: panel.title,
  });

  return {
    builderProps: {
      ...handlers.builderProps,
      defaultLayout: (selector.formConfigQuery.data?.layout ?? EMPTY_LAYOUT) as SerializedNodes,
      initialScoreSections: selector.formConfigQuery.data?.scoreSections ?? [],
      initialVariables: selector.formConfigQuery.data?.variables ?? [],
      loading: selector.formConfigQuery.isInitialLoading,
      formConfigSettingPanel: panel.panelComponent,
    },
    selectorProps: selector.selectorProps,
    createConfigModal: handlers.createConfigModal,
  };
};
